export default {"src":"/_next/static/media/icono4punto.41b0f5e8.svg","height":1080,"width":1080,"blurWidth":0,"blurHeight":0};